<template>
    <div class="container-fluid">
        <div class="row" style="height: 100%">
            <div class="side_bar_custom">
                <Menu :model="items"/>
            </div>  
            <div class="col main_table">
                <div class="container-fluid" >
                    <router-view />
                </div>
            </div>
        </div>
        <div class="menu-mobile justify-content-end">
            <div class="col">
                <Button icon="fa fa-bars" class="sidebar-button p-button-raised p-button-rounded color-button-menu" style="color: white;" @click="visibleRight = true"/>
            </div>
        </div>
    </div>

    <Sidebar v-model:visible="visibleRight" position="left">
        <Menu :model="items"/>    
    </Sidebar>
</template>

<script>
import Menu from 'primevue/menu'
import Sidebar from 'primevue/sidebar'
import Button from 'primevue/button'

export default {
    name: 'Billing',
    components: {
        Menu,
        Sidebar,
        Button,
    },
    data() {
        return {
            visibleRight: false,
            color: localStorage.getItem('primary_color'),
            opacity_color: '',
            rgba_color: '',
            items: [
                {
                    label: 'BILLS',
                    items: [
                        {
                            label: 'Dashboard',
                            to: '/billing/dashboard',
                            command: () => {
                                this.visibleRight = false
                            },
                        },
                        {
                            label: 'Settlement',
                            to: '/billing/settlement',
                            command: () => {
                                this.visibleRight = false
                            },
                        },
                    ],
                },
                {
                    label: 'ACCOUNTING',
                    visible: () => {
                        if(this.check_bill_manager == true || this.get_current_user.is_superuser == true) {
                            return true
                        }
                    },
                    items: [
                        {
                            label: 'Validated',
                            to: '/billing/accounting_validated',
                            command: () => {
                                this.visibleRight = false
                            },
                        },
                        {
                            label: 'Accounted',
                            to: '/billing/accounting_accounted',
                            command: () => {
                                this.visibleRight = false
                            },
                        }
                    ]
                },     
                {
                    label: 'PAYMENT PROPOSAL',
                    visible: () => {
                        if(this.check_bills_responsibles == true || this.check_accounting_manager == true) {
                            return true
                        }
                    },
                    items: [
                        {
                            label: 'Dashboard',
                            to: '/billing/payment_proposal',
                            command: () => {
                                this.visibleRight = false
                            },
                        },
                    ]
                }
            ]
        }
    },
    computed: {
        get_current_user: function() {
            return this.$store.getters.get_current_user
        },
        check_bill_manager: function() {
            for(var index in this.get_current_user.groups) {
                if(this.get_current_user.groups[index].name == 'Bill manager') {
                    return true
                }
            }
            return false
        },
        check_bills_responsibles: function() {
            for(var index in this.get_current_user.groups) {
                if(this.get_current_user.groups[index].name == 'Bills responsibles') {
                    return true
                }
            }
            return false
        },
        check_accounting_manager: function() {
            for(var index in this.get_current_user.groups) {
                if(this.get_current_user.groups[index].name == 'Accounting Manager') {
                    return true
                }
            }
            return false
        },
    },
    mounted() {
        if(this.color == '#6E3FA3') {
            this.opacity_color = 'rgba(108, 67, 154, .3)'
        } else if (this.color == '#0097A9') {
            this.opacity_color = 'rgba(0, 151, 169, .3)'
        }
        this.$router.push('/billing/dashboard')
    }
}
</script>

<style scoped>

.side_bar_custom{
    position: fixed;
    width: 300px;
    height: calc(100vh - 11rem);
    z-index: 3;
    overflow-y: auto;
    user-select: none;
    top: 9rem;
    left: 2rem;
    transition: transform 0.2s, left 0.2s;
    background-color: var(--surface-overlay);
    border-radius: 12px;
    padding: 0.5rem 0.5rem;
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);
}

.main_table {
    margin-left: 300px;
    flex-direction: column;
    min-height: calc(100vh - 9rem);
    justify-content: space-between;
    padding-left: 2rem;
    transition: margin-left 0.2s;
}

@media (min-width: 1300px) {
    .menu-mobile {
        display: none;

    }

    :deep(.p-scrollpanel .p-scrollpanel-bar) {
        background-color: #a8a8a8;
        transition: #a8a8a8 .2s;
    }

    :deep(.p-scrollpanel .p-scrollpanel-bar:hover) {
        background-color: #a8a8a8;
    }
}

@media (max-width: 1301px) {
    .side_bar_custom {
        display: none;
    }
    .main_table{
        margin-left: 0px !important;
        padding-left: 0px !important;
    }
}

:deep(.p-scrollpanel .p-scrollpanel-bar) {
    background-color: #a8a8a8;
    transition: #a8a8a8 .2s;
}    

:deep(.p-scrollpanel .p-scrollpanel-bar:hover) {
    background-color: #a8a8a8;
}

.sidebar-button {
    border-radius: 10px;
    left: 82vw !important;
    top: 90% !important;
    position: fixed !important;
    z-index: 1000;
}

:deep(.p-menu) {
    border-radius: 0px;
    background: rgba(0,0,0,0); 
    padding: 0;
}

:deep(.p-menu .p-menuitem-link) {
    margin-left: 0px;
}


.scroll_menu{
    background-color: v-bind(opacity_color);
}

:deep(.p-scrollpanel-content){
    padding: 0;

}

:deep(.p-menu .p-submenu-header){
    background-color: rgba(0,0,0,0); 
    border-radius: 6px;
}

/*
:deep(.bm-item-list) {
    margin-left: 0px !important;
}

:deep(.bm-menu) {
    background-color: #eaeaea;
    box-shadow: 0 9px 10px -1px rgba(0,0,0,.2), 0 9px 10px 0 rgba(0,0,0,.14), 0 4px 5px 0 rgba(0,0,0,.12);
}
*/

.card {
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);
    margin-bottom: 1rem;
}

.color-button-menu{
    color: white;
    background-color: v-bind(color);
    border-color: v-bind(color);
}

.color-button-menu:hover{
    background-color: v-bind(color) !important;
    border-color: v-bind(color) !important; 
    opacity: .8;
}

:deep(.router-link-active .p-menuitem-text){
    color: v-bind(color) !important;
    font-weight: 700;
}

:deep(.router-link-active .p-menuitem-icon){
    color: v-bind(color) !important;
}

:deep(.p-menu .p-menuitem-link:not(.p-disabled):hover){
    border-radius: 10px;
}

.sidebar_color{
    background-color: red !important;
}

:deep(.p-scrollpanel-bar-x){
    height: 0px;
}

</style>